import React from 'react';
import { GripVertical, Trash2 } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import GoogleInput from './GoogleInput';

export const SortableItem = ({ id, point, index, onRemove, onChange }) => {
   const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 60 : 'auto',
        opacity: isDragging ? 0.8 : 1,
    };
    const className = 'flex-1 outline-none text-sm'
    return (
        <div
            ref={setNodeRef}
            style={style}
            className="flex items-center gap-3 bg-white p-3 rounded-xl border border-gray-200 mb-3"
        >
            <div
                {...attributes}
                {...listeners}
                className="cursor-grab active:cursor-grabbing p-1 -ml-1"
                style={{ touchAction: 'none' }}
            >
                <GripVertical className="w-5 h-5 text-gray-400" />
            </div>
            <span className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center text-xs font-bold text-gray-500">
                {index + 1}
            </span>
            <GoogleInput
                value={point.address}
                className={className}
                placeholder="Enter Pickup/Drop Point location"
                onSelect={(place) => {
                    console.log("points google input", place.address, place.lat, place.lng)
                    onChange(index, place.address, place.lat, place.lng);
                }
                }
            />
            {/* <input
                placeholder="Enter point address"
                className="flex-1 outline-none text-sm"
                value={point.address}
                onChange={(e) => onChange(index, e.target.value)}
            /> */}
            <button type="button" onClick={() => onRemove(id)}>
                <Trash2 className="w-4 h-4 text-rose-500" />
            </button>
        </div>
    );
};
